import {toast, type ToastContentProps} from 'react-toastify';

import {Observer} from 'mobx-react';

import YcCoin from '@src/modules/UserCertification/YcCoin/YcCoin';

import styles from './styles.module.css';

interface Props {
  className?: string;
  description?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  qty?: string;
  text?: string;
  title?: string;
}

export const YCToast = ({
  data,
  toastProps: {toastId},
}: ToastContentProps<Props>) => {
  const {description = '', onClick, qty, text = '', title} = data;

  const onClickCb = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (onClick) {
      onClick(e);

      toast.dismiss(toastId);
    }
  };

  return (
    <Observer>
      {() => (
        <div
          className={`YCToast ${styles.YCToast}`}
          onClick={onClickCb}
          style={{
            cursor: onClick ? 'pointer' : 'default',
          }}
        >
          <div className={styles.YcCoinContainer}>
            <YcCoin size={34} />
          </div>
          <div className={styles.contentContainer}>
            <div className={styles.text}>
              {text}
              {qty}
            </div>
            {description && (
              <div className={styles.description}>{`${description} ${
                title ? title : ''
              }`}</div>
            )}
          </div>
        </div>
      )}
    </Observer>
  );
};
